export const styles = {
    /* Layout */
    container:
        "min-h-screen bg-[#0F1720] overflow-hidden",

    wrapper:
        "grid min-h-screen grid-cols-1 lg:grid-cols-2",

    /* Left */

    leftPanel:
        "relative overflow-hidden bg-[#0D2018] text-white hidden lg:block",

    glow:
        "absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(29,158,117,.18),transparent_70%)]",

    leftContent:
        "relative z-10 flex h-full flex-col justify-between px-8 py-8 xl:px-14 xl:py-10",

    logo:
        "w-36 xl:w-44 h-auto",

    headingContainer:
        "max-w-md",

    heading:
        "font-serif text-4xl xl:text-5xl 2xl:text-6xl font-semibold leading-tight",

    headingItalic:
        "font-serif text-4xl xl:text-5xl 2xl:text-6xl italic font-light text-[#A9D6C4] leading-tight",

    description:
        "mt-4 text-sm xl:text-base leading-7 text-white/60",

    featureList:
        "mt-8 space-y-4",

    featureItem:
        "flex items-center gap-3",

    featureIcon:
        "flex h-6 w-6 items-center justify-center rounded-full bg-[#12694B]",

    featureText:
        "text-sm xl:text-base text-white/80",

    footer:
        "text-xs text-white/30",

    /* Right */

    rightPanel:
        "flex items-center justify-center bg-[#FBFBF8] px-5 py-8 sm:px-8 md:px-12 lg:px-16 xl:px-20",

    form:
        "w-full max-w-sm sm:max-w-md",

    /* Top */

    topLink:
        "mb-5 flex justify-end",

    topLinkText:
        "text-xs sm:text-sm text-gray-400",

    topLinkButton:
        "font-semibold text-[#0F7A5C] hover:underline",

    /* Heading */

    title:
        "font-fraunces text-3xl sm:text-[30px] lg:text-[32px] font-medium leading-tight text-[#13211B]",

    subtitle:
        "mt-3 text-sm sm:text-base leading-6 text-gray-500",

    /* Toggle */

    toggleContainer:
        "mt-5 flex rounded-xl border border-[#DED8CC] bg-[#F6F3EA] p-1",

    toggleButton:
        "flex-1 rounded-lg py-2.5 text-sm font-semibold transition",

    toggleActive:
        "bg-white text-[#10231D] shadow",

    toggleInactive:
        "text-[#6D8077]",

    /* Social */

    googleButton:
        "mt-5 flex h-12 sm:h-14 w-full items-center justify-center gap-3 rounded-xl border border-gray-300 bg-white text-sm sm:text-base font-semibold transition hover:bg-gray-50",

    appleButton:
        "mt-3 flex h-12 sm:h-14 w-full items-center justify-center gap-3 rounded-xl bg-[#10231D] text-sm sm:text-base font-semibold text-white transition hover:bg-[#0D1C17]",

    socialIcon:
        "h-5 w-5",

    /* Divider */

    divider:
        "my-5 flex items-center",

    dividerLine:
        "h-px flex-1 bg-gray-300",

    dividerText:
        "mx-4 text-[10px] sm:text-xs font-semibold tracking-[3px] uppercase text-gray-400",

    /* Labels */

    labelRow:
        "mb-2 flex items-center justify-between",

    label:
        "text-[10px] tracking-[2px] font-bold uppercase text-gray-400",

    switchButton:
        "text-xs sm:text-sm font-semibold text-[#0F7A5C] hover:underline",

    /* Input */

    input:
        "h-12 sm:h-14 w-full rounded-xl border border-[#D9D7D0] bg-white px-4 text-sm sm:text-base outline-none transition-all duration-300 placeholder:text-[#AEB3B0] focus:border-[#1D9E75] focus:ring-4 focus:ring-[#1D9E75]/10",

    hint:
        "mt-2 text-xs text-gray-400",

    /* Continue */

    continueButton:
        "mt-6 flex h-12 sm:h-14 w-full items-center justify-center gap-2 rounded-xl border text-sm sm:text-base font-semibold transition-all",

    continueActive:
        "border-[#1D9E75] bg-[#1D9E75] text-white hover:bg-[#167C5C]",

    continueDisabled:
        "cursor-not-allowed border-[#DDD8CB] bg-[#F3F0E7] text-[#A6AAA3]",

    /* Terms */

    terms:
        "mt-5 text-center text-[11px] sm:text-xs leading-5 text-gray-400",

    termsLink:
        "font-semibold text-[#4B5A54] hover:text-[#1D9E75]",
};